export default __webpack_public_path__ + "static/media/OdibeeSans-Regular.ad7b55a4.ttf";